import { commonMessages } from '../../../../util/messages'

export const ratingCompliancesRulesMessages = {
  common: commonMessages,
  create: {
    success: 'Rating compliance rule successfully crated',
    error: 'Error creating rating compliance rule',
  },
  update: {
    success: 'Rating compliance rule successfully updated',
    error: 'Error updating rating compliance rule',
  },
  delete: {
    success: 'Rating compliance rule successfully deleted',
    error: 'Error deleting rating compliance rule',
  },
}
